import React from "react";
import moment from "moment-timezone";

export const DateTimeFormate = (timeStemp) => {
  let d = new Date(parseInt(timeStemp));
  let output = moment.tz(d, "America/Los_Angeles").format("MM/DD/YYYY, h:mm A");
  if (output !== "Invalid date") {
    return output;
  } else {
    return <b className="text-center">-</b>;
  }
};

export const DateTimeFormateSeconds = (timeStemp) => {
  let d = new Date(parseInt(timeStemp * 1000));
  let output = moment.tz(d, "America/Los_Angeles").format("MM/DD/YYYY, h:mm A");
  if (output !== "Invalid date") {
    return output;
  } else {
    return <b className="text-center">-</b>;
  }
};
export const DateFormate = (timeStemp) => {
  if (!timeStemp || !moment(timeStemp).isValid()) {
    return "-";
  }
  return moment(new Date(timeStemp)).format("MM/DD/YYYY");
};

export const DataFormate = (timeStemp) => {
  let d = new Date(parseInt(timeStemp));
  let output = moment.tz(d, "America/Los_Angeles").format("MM/DD/YYYY");
  if (output !== "Invalid date") {
    return output;
  } else {
    return "-";
  }
};

export const TimeFormate = (timeStemp) => {
  let d = new Date(parseInt(timeStemp));
  let output = moment.tz(d, "America/Los_Angeles").format("h:mm A");
  if (output !== "Invalid date") {
    return output;
  } else {
    return "-";
  }
};

export const DateTimeFormateERI = (timeStemp) => {
  if (!timeStemp) return <b className="text-center">-</b>;

  // Parse timestamp with fallback to UTC if not already a moment object
  const momentObj = moment.utc(timeStemp);

  if (!momentObj.isValid()) {
    return <b className="text-center">-</b>;
  }

  // Convert to America/Los_Angeles time zone (handles PST/PDT automatically)
  const output = momentObj
    .tz("America/Los_Angeles")
    .format("MM/DD/YYYY, h:mm A");

  return output !== "Invalid date" ? output : <b className="text-center">-</b>;
};

export const getTimeStampForReports = () => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const parts = formatter.formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;

  // Replace : once here (cleaner)
  return `${get('month')}-${get('day')}-${get('year')}-${get('hour')}-${get('minute')}-${get('second')}-${get('dayPeriod')}`;
};
